import React from "react";
import PackagesGrid from "../components/PackagesGrid";
import BookCTA from "../components/BookCTA";
import FAQ from "../components/FAQ";

export default function PackagesPage() {
  return (
    <>
      <section className="pt-[120px] lg:pt-[160px] pb-12 bg-[var(--lc-cream)]">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
          <div className="eyebrow text-[var(--lc-moss)] mb-5">Standard Packages</div>
          <h1 className="font-serif-display text-[clamp(40px,6.5vw,92px)] leading-[1] font-light max-w-4xl">
            Three plans, fully <span className="italic">flexible.</span>
          </h1>
          <p className="mt-7 max-w-xl text-[15px] leading-relaxed text-[var(--lc-muted)]">
            Every package is 100% adaptable. We modify pillars to align with
            your goals, schedule and budget — no rigid contracts.
          </p>
        </div>
      </section>
      <PackagesGrid withHeader={false} />
      <FAQ />
      <BookCTA />
    </>
  );
}
